/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";

// import firebase from 'firebase/app'
// import 'firebase/auth'

Vue.use(Router)

const router = new Router({

  //  mode: 'history',

  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================

        {
          path: '/CourseCatalogReport',
          name: 'CourseCatalogReport',
          component: () => import('./views/report/CourseCatalog.vue'),
          meta: {
            rule: 'editor',
            pageTitle: "CourseCatalog",
            authRequired: false
          }
        },


        {
          path: '/InstructorHome',
          name: 'InstructorHome',
          component: () => import('./views/instructor/Home.vue'),
          meta: {
            rule: 'instructor',
            pageTitle: "Home",
            authRequired: true
          }
        },


        {
          path: '/CustomerHome',
          name: 'Customerhome',
          component: () => import('./views/customer/Home.vue'),
          meta: {
            rule: 'customer',
            pageTitle: "Home",
            authRequired: true
          }
        },
        {
          path: '/Traineehome',
          name: 'Traineehome',
          component: () => import('./views/trainee/TraineeHome.vue'),
          meta: {
            rule: 'trainee',
            pageTitle: "Home",
            authRequired: true
          }
        },

        {
          path: '/home',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            rule: 'admintrainingcoordinator',
            pageTitle: "Home",
            authRequired: true
          }
        },
        {
          path: '/home',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            rule: 'Coordinator',
            pageTitle: "Home",
            authRequired: true
          }
        },
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            rule: 'all',
            pageTitle: "Home",
            authRequired: true
          }
        },

        {
          path: '/CustomerCourseRequest',
          name: 'CustomerCourseRequest',
          component: () => import('@/views/customer/CustomerCourseRequest.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRequest' },
            ],
            pageTitle: 'CourseRequest',
            rule: 'customer'
          },
        },
        {
          path: '/TraineeOfCustomer',
          name: 'TraineeOfCustomer',
          component: () => import('@/views/customer/TraineeOfCustomer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Trainees' },
            ],
            pageTitle: 'Trainees',
            rule: 'customer'
          },
        },
        {
          path: '/TraineeExamResult',
          name: 'TraineeExamResult',
          component: () => import('@/views/customer/TraineeExamResult.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ExamResult' },
            ],
            pageTitle: 'ExamResult',
            rule: 'customer'
          },
        },
        {
          path: '/TraineeSchedule',
          name: 'TraineeSchedule',
          component: () => import('@/views/customer/TraineeSchedule.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeSchedule' },
            ],
            pageTitle: 'TraineeSchedule',
            rule: 'customer'
          },
        },

        {
          path: '/AttendanceTrainee',
          name: 'AttendanceTrainee',
          component: () => import('@/views/customer/AttendanceTrainee.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeAttendance' },
            ],
            pageTitle: 'TraineeAttendance',
            rule: 'customer'
          },
        },


        {
          path: '/advertisement',
          name: 'advertisement',
          component: () => import('@/views/coordinateProposal/CoordinateProposal.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'advertisement' },
            ],
            pageTitle: 'advertisement',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/InstructorSchedule',
          name: 'InstructorSchedule',
          component: () => import('@/views/instructorPlaning/AnnualPlan.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'InstructorSchedule' },
            ],
            pageTitle: 'InstructorSchedule',
            rule: 'instructor'
          },
        },
        {
          path: '/InstructorTraineeAttendance',
          name: 'InstructorTraineeAttendance',
          component: () => import('@/views/instructorTraineeAttendance/TraineeAttendance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeAttendance' },
            ],
            pageTitle: 'TraineeAttendance',
            rule: 'instructor'
          },
        },


        {
          path: '/InstructorTraineeExam/:ID?/:CourseClassID?',
          name: 'InstructorTraineeExam',
          component: () => import('@/views/instructorMarkExam/InstructorTraineeExam.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeExam' },
            ],
            pageTitle: 'TraineeExam',
            rule: 'instructor'
          },
        },
        {
          path: '/InstructorMarkExam',
          name: 'InstructorMarkExam',
          component: () => import('@/views/instructorMarkExam/ListOfTrainee.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'InstructorMarkExam' },
            ],
            pageTitle: 'InstructorMarkExam',
            rule: 'instructor'
          },
        },
        {
          path: '/MarkTraineeExam/:ExamID?/:TraineeID?/:CourseClassID?',
          name: 'MarkTraineeExam',
          component: () => import('@/views/instructorMarkExam/MarkTraineeExam.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'MarkTraineeExam' },
            ],
            pageTitle: 'MarkTraineeExam',
            rule: 'instructor'
          },
        },
        {
          path: '/RequestCourseClass',
          name: 'RequestCourseClass',
          component: () => import('@/views/trainee/RequestCourse.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRequest' },
            ],
            pageTitle: 'CourseRequest',
            rule: 'trainee'
          },
        },
        {
          path: '/ExamResult',
          name: 'ExamResult',
          component: () => import('@/views/trainee/ExamResult.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ExamResult' },
            ],
            pageTitle: 'ExamResult',
            rule: 'trainee'
          },
        },
        {
          path: '/TraineeCertification',
          name: 'TraineeCertification',
          component: () => import('@/views/trainee/TraineeCertification.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeCertification' },
            ],
            pageTitle: 'TraineeCertification',
            rule: 'trainee'
          },
        },
        {
          path: '/ReviewAnswer/:Code?',
          name: 'ReviewAnswer',
          component: () => import('@/views/trainee/availableReview/ReviewAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ReviewAnswer' },
            ],
            pageTitle: 'ReviewAnswer',
            rule: 'trainee'
          },
        },
        {
          path: '/AvailableReview',
          name: 'AvailableReview',
          component: () => import('@/views/trainee/availableReview/availableReview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AvailableFeedback' },
            ],
            pageTitle: 'AvailableFeedback',
            rule: 'trainee'
          },
        },
        {
          //mkl
          path: '/AvailableInstructorReview',
          name: 'AvailableInstructorReview',
          component: () => import('@/views/instructor/AvailableInstructorReview/availableReview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AvailableInstructorReview' },
            ],
            pageTitle: 'AvailableInstructorReview',
            rule: 'instructor'
          },
        },
        {
          path: '/ReviewInstructorAnswer/:CourseClassID?',
          name: 'ReviewInstructorAnswer',
          component: () => import('@/views/instructor/AvailableInstructorReview/ReviewAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ReviewInstructorAnswer' },
            ],
            pageTitle: 'ReviewInstructorAnswer',
            rule: 'instructor'
          },
        },
        {
          path: '/InstructorsFeedBack',
          name: 'InstructorsFeedBack',
          component: () => import('@/views/instructor/InstructorFeedBack/availableReview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'InstructorsFeedBack' },
            ],
            pageTitle: 'InstructorsFeedBack',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/InstructorFeedBackAnswer/:instructorAnswer?',
          name: 'InstructorFeedBackAnswer',
          component: () => import('@/views/instructor/InstructorFeedBack/ReviewAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'InstructorFeedBackAnswer' },
            ],
            pageTitle: 'InstructorFeedBackAnswer',
            rule: 'admin'
          },
        },
        {
          path: '/InstructorAssessment',
          name: 'InstructorAssessment',
          component: () => import('@/views/customerReview/instructorAssessmentAnswer/InstructorAssessment.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Assessment' },
            ],
            pageTitle: 'Assessment',
            rule: 'Assessment'
          },
        },

        {
          path: '/InstructorAssessmentAnswer/:Code?',
          name: 'InstructorAssessmentAnswer',
          component: () => import('@/views/customerReview/instructorAssessmentAnswer/InstructorAssessmentAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AssessmentResult' },
            ],
            pageTitle: 'AssessmentResult',
            rule: 'Assessment'
          },
        },
        {
          path: '/InstructorAssessmentResult',
          name: 'InstructorAssessmentResult',
          component: () => import('@/views/customerReview/instructorAssessmentResult/InstructorAssessmentResult.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AssessmentResult' },
            ],
            pageTitle: 'AssessmentResult',
            rule: 'editor'
          },
        },
        {
          path: '/InstructorAssessmentResultDetail/:Code?',
          name: 'InstructorAssessmentResultDetail',
          component: () => import('@/views/customerReview/instructorAssessmentResult/InstructorAssessmentAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AssessmentAnswer' },
            ],
            pageTitle: 'AssessmentAnswer',
            rule: 'editor'
          },
        },

        {
          path: '/InstructorGeneralPracticalAnswer',
          name: 'InstructorGeneralPracticalAnswer',
          component: () => import('@/views/traineeCoursesInstructor/InstructorGeneralPracticalAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'PracticalEvaluationAnswer' },
            ],
            pageTitle: 'PracticalEvaluationAnswer',
            rule: 'adminevaluatorinstructorCoordinator'
          },
        },
        {
          path: '/CourseMaterial',
          name: 'CourseMaterial',
          component: () => import('@/views/trainee/courseMaterial/courseMaterial.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseMaterial' },
            ],
            pageTitle: 'CourseMaterial',
            rule: 'traineeInstructor'
          },
        },
        {
          path: '/CourseMaterialDetail/:Code?',
          name: 'CourseMaterialDetail',
          component: () => import('@/views/trainee/courseMaterial/courseMaterialDetail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseMaterialDetail' },
            ],
            pageTitle: 'CourseMaterialDetail',
            rule: 'traineeInstructor'
          },
        },
        {
          path: '/ConfirmRegistration/:ID?',
          name: 'ConfirmRegistration',
          component: () => import('@/views/trainee/ConfirmRegistration.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ConfirmRegistration' },
            ],
            pageTitle: 'ConfirmRegistration',
            rule: 'trainee',
            authRequired: true,

          },
        },
        {
          path: '/ConfirmCustomRegistration/:ID?',
          name: 'ConfirmCustomRegistration',
          component: () => import('@/views/trainee/ConfirmCustomRegistration.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ConfirmCustomRegistration' },
            ],
            pageTitle: 'ConfirmCustomRegistration',
            rule: 'trainee'
          },
        },
        {
          path: '/ConfirmRequestRegistration/:ID?',
          name: 'ConfirmRequestRegistration',
          component: () => import('@/views/trainee/ConfirmRequestRegistration.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ConfirmRequestRegistration' },
            ],
            pageTitle: 'ConfirmRequestRegistration',
            rule: 'trainee'
          },
        },
        {
          path: '/RegistrationStatus/:Code?',
          name: 'RegistrationStatus',
          component: () => import('@/views/trainee/RegistrationStatus.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'RegistrationStatus' },
            ],
            pageTitle: 'RegistrationStatus',
            rule: 'trainee'
          },
        },


        //course
        {
          path: '/Course',
          name: 'Course',
          component: () => import('./views/course/Course.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Course', url: '/Course/', active: true },
            ],
            rule: 'admintrainingcoordinator',
            pageTitle: "Course",
          }
        },
        {
          path: '/CourseDetail/:ID?',
          name: 'CourseDetail',
          component: () => import('./views/trainee/CourseDetail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseDetail', url: '/CourseDetail/', active: true },
            ],
            rule: 'customertrainee',
            pageTitle: "CourseDetail",
            authRequired: true
          }
        },
        {
          path: '/CourseRequest',
          name: 'CourseRequest',
          component: () => import('@/views/courseRequest/CourseRequest.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRequest', active: true },
            ],
            pageTitle: 'CourseRequest',
            rule: 'courserequest'
          },
        },
        {
          path: '/FollowCourseRequest',
          name: 'FollowCourseRequest',
          component: () => import('@/views/courseRequest/FollowCourseRequest.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'FollowCourseRequest', active: true },
            ],
            pageTitle: 'FollowCourseRequest',
            rule: 'customertrainee'
          },
        },
        //track
        {
          path: '/CourseTrack',
          name: 'CourseTrack',
          component: () => import('./views/track/Track.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Diplomas', url: '/CourseTrack/', active: true },
            ],
            rule: 'editor',
            pageTitle: "Diplomas",
          }
        },
        {
          path: '/Track-Edit/:ID?',
          name: 'Track-add/Edit',
          component: () => import('./views/track/Track-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Track', url: '/Track' },
              { title: 'TrackAddEdit', active: true },
            ],
            pageTitle: "TrackAddEdit"
          }
        },
        {
          path: '/CourseRequest-Edit/:ID?',
          name: 'CourseRequest-add/Edit',
          component: () => import('./views/courseRequest/CourseRequest-edit.vue'),
          meta: {
            rule: 'courserequest',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRequest', url: '/CourseRequest' },
              { title: 'CourseRequestAddEdit', active: true },
            ],
            pageTitle: "CourseRequestAddEdit"
          }
        },
        {
          path: '/CourseRequestCosting',
          name: 'CourseRequestCosting',
          component: () => import('./views/courseRequest/CourseRequestCosting.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRequest', url: '/CourseRequest' },
              { title: 'CourseRequestCosting', active: true },
            ],
            pageTitle: "CourseRequestCosting"
          }
        },
        {
          path: '/MainCourseRegistration',
          name: 'MainCourseRegistration',
          component: () => import('@/views/courseRegistration/MainCourseRegistration.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRegistration', active: true },
            ],
            pageTitle: 'CourseRegistration ',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/CourseRegistration/:CourseID?/:CourseClassID?/:AnnualPlanID?',
          name: 'CourseRegistration',
          component: () => import('@/views/courseRegistration/CourseRegistration.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRegistration', active: true },
            ],
            pageTitle: 'CourseRegistration ',
            rule: 'admintrainingcoordinator'
          },
        },
        //CourseRegistration
        {
          path: '/FollowRegistration',
          name: 'FollowRegistration',
          component: () => import('@/views/courseRegistration/FollowRegistration.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'FollowRegistration', active: true },
            ],
            pageTitle: 'FollowRegistration ',
            rule: 'trainee'
          },
        },
        {
          path: '/UpcomingCourse',
          name: 'UpcomingCourse',
          component: () => import('@/views/trainee/UpcomingCourse.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'UpcomingCourse', active: true },
            ],
            pageTitle: 'UpcomingCourse ',
            rule: 'customertrainee'
          },
        },
        {
          path: '/CourseList/:ID?',
          name: 'CourseList',
          component: () => import('@/views/trainee/CourseList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseList', active: true },
            ],
            pageTitle: 'CourseList',
            rule: 'customertrainee'
          },
        },
        {
          path: '/CourseRegistration-Edit/:ID',
          name: 'CourseRegistration-add/Edit',
          component: () => import('./views/courseRegistration/CourseRegistration-edit.vue'),
          meta: {
            rule: 'courseregistration',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseRegistration', url: '/CourseRegistration' },
              { title: 'CourseRegistrationAddEdit', active: true },
            ],
            pageTitle: "CourseRegistrationAddEdit"
          }
        },

        {
          path: '/Setting/Course-Edit/:ID?',
          name: 'Course-add/Edit',
          component: () => import('./views/course/Course-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Course', url: '/Setting/Course' },
              { title: 'CourseAddEdit', active: true },
            ],
            pageTitle: "CourseAddEdit"
          }
        },
        //CourseExam
        {
          path: '/CourseExam',
          name: 'CourseExam',
          component: () => import('./views/courseExam/CourseExam.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseExam', url: '/CourseExam/', active: true },
            ],
            rule: 'admintrainingcoordinator',
            pageTitle: "CourseExam",
          }
        },
        {
          path: '/courseExam/CourseExam-Edit',
          name: 'CourseExam-add/Edit',
          component: () => import('./views/courseExam/CourseExam-Edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'user' },
              { title: 'CourseExam', url: '/CourseExam' },
              { title: 'CourseExamAddEdit', active: true },
            ],
            pageTitle: "CourseExamAddEdit"
          }
        },
        //instrucror
        {
          path: '/Instructor',
          name: 'Instructor',
          component: () => import('./views/instructor/Instructor.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Instructor', url: '/Instructor/', active: true },
            ],
            rule: 'editor',
            pageTitle: "Instructor"
          },

        },
        {
          path: '/Instructor/Add-Edit',
          name: 'Add-Edit',
          component: () => import('./views/instructor/add-edit/Add-Edit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Instructor', url: '/Instructor/' },
              { title: 'Data', active: true },
            ],
            rule: 'editor',
            pageTitle: "InstructorAddEdit"
          },

        },
        {
          path: '/Instructor/InstructorHistory',
          name: 'InstructorHistory',
          component: () => import('./views/instructor/InstructorHistory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Instructor', url: '/Instructor/' },
              { title: 'InstructorHistory', active: true },
            ],
            rule: 'editor',
            pageTitle: "InstructorHistory"
          },

        },
        {
          path: '/user',
          name: 'UserManagement',
          component: () => import('@/views/user/User.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users' },
              { title: 'UserManagement', active: true },
            ],
            pageTitle: 'UserManagement',
            rule: 'editor'
          },
        },
        {
          path: 'User/Organization',
          name: 'Customer',
          component: () => import('@/views/user/customer/Customer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users' },
              { title: 'Organization', active: true },
            ],
            pageTitle: 'Organization',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/User/Organization-Edit',
          name: 'Organization-add/Edit',
          component: () => import('./views/user/customer/Customer-edit.vue'),
          meta: {
            rule: 'admintrainingcoordinator',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'user' },
              { title: 'Organizations', url: '/User/Organization' },
              { title: 'OrganizationAddEdit', active: true },
            ],
            pageTitle: "OrganizationAddEdit"
          }
        },
        {
          path: '/User/CustomerHistory/:ID?',
          name: 'CustomerHistory',
          component: () => import('./views/user/customer/CustomerHistory.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'user' },
              { title: 'Organizations', url: '/User/Organization' },
              { title: 'OrganizationHistory', active: true },
            ],
            pageTitle: "OrganizationHistory"
          }
        },
        {
          path: 'User/Trainee',
          name: 'Trainee',
          component: () => import('@/views/user/trainee/Trainee.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users' },
              { title: 'Trainee', active: true },
            ],
            pageTitle: 'Trainee ',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: 'User/TraineeCourses/:ID?',
          name: 'TraineeCourses',
          component: () => import('@/views/user/trainee/TraineeCourses.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users' },
              { title: 'TraineeCourses', active: true },
            ],
            pageTitle: 'TraineeCourses',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: 'User/TraineeHistory/:ID?',
          name: 'TraineeHistory',
          component: () => import('@/views/user/trainee/TraineeHistory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users' },
              { title: 'TraineeHistory', active: true },
            ],
            pageTitle: 'TraineeHistory ',
            rule: 'editor'
          },
        },
        {
          path: 'User/TraineePass/:CourseClassID?/:TraineeID?',
          name: 'TraineePass',
          component: () => import('@/views/user/trainee/TraineePass.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users' },
              { title: 'TraineePass', active: true },
            ],
            pageTitle: 'TraineePass ',
            rule: 'editor'
          },
        },

        {
          path: '/User/Trainee-Edit',
          name: 'Trainee-add/Edit',
          component: () => import('./views/user/trainee/Trainee-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'user' },
              { title: 'Trainee', url: '/User/Trainee' },
              { title: 'TraineeAddEdit', active: true },
            ],
            pageTitle: "TraineeAddEdit"
          }
        },

        {
          path: '/dashboard/analytics',
          name: 'dashboard-analytics',
          component: () => import('./views/DashboardAnalytics.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard' },
              { title: 'Analytics', active: true },
            ],
            pageTitle: "Analytics"
          }
        },

        {
          path: '/Statistics/QuestionPassStatistics',
          name: 'dashboard-PassStatistics',
          component: () => import('./views/statistics/PassStatistics.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'QuestionPassStatistics', active: true },
            ],
            pageTitle: "QuestionPassStatistics"
          }
        },
        {
          path: '/Statistics/CoursePassStatistics',
          name: 'dashboard-PassStatistics',
          component: () => import('./views/statistics/CoursePassStatistics.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CoursePassStatistics', active: true },
            ],
            pageTitle: "CoursePassStatistics"
          }
        },
        {
          path: '/LogActions/LogAction',
          name: 'LogActions',
          component: () => import('./views/LogAction/LogActions.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'LogAction', active: true },
            ],
            pageTitle: "LogActions"
          }
        },
        {
          path: '/FeedbackAction/FeedbackAction',
          name: 'FeedbackAction',
          component: () => import('./views/FeedbackAction/FeedbackAction.vue'),
          meta: {
            rule: 'anonymous',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'FeedbackAction', active: true },
            ],
            pageTitle: "FeedbackAction"
          }
        },
        {
          path: '/FeedbackAction/FeedbackAction-Edit/:ID?',
          name: 'FeedbackAction-add/Edit',
          component: () => import('./views/FeedbackAction/FeedbackAction-edit.vue'),
          meta: {
            rule: 'anonymous',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'FeedbackAction', url: '/FeedbackAction/FeedbackAction' },
              { title: 'FeedbackActionEdit', active: true },
            ],
            pageTitle: "FeedbackActionEdit"
          }
        },

        {
          path: '/Setting/Language',
          name: 'Language',
          component: () => import('./views/settings/language/Language.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Language', active: true },
            ],
            pageTitle: "Language"
          }
        },
        {
          path: '/Setting/AnnualCalender',
          name: 'AnnualCalender',
          component: () => import('./views/settings/annualCalender/AnnualCalender.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'AnnualCalender', active: true },
            ],
            pageTitle: "AnnualCalender"
          }
        },
        {
          path: '/Setting/ParticipationType',
          name: 'ParticipationType',
          component: () => import('./views/settings/participationType/ParticipationType.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'ParticipationType', active: true },
            ],
            pageTitle: "ParticipationType"
          }
        },
        {
          path: '/Setting/PaymentType',
          name: 'PaymentType',
          component: () => import('./views/settings/paymentType/PaymentType.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'PaymentType', active: true },
            ],
            pageTitle: "PaymentType"
          }
        },
        {
          path: '/Setting/RequestLocation',
          name: 'RequestLocation',
          component: () => import('./views/settings/requestLocation/RequestLocation.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'RequestLocation', active: true },
            ],
            pageTitle: "RequestLocation"
          }
        },
        {
          path: '/Setting/Status',
          name: 'Status',
          component: () => import('./views/settings/status/Status.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Status', active: true },
            ],
            pageTitle: "Status"
          }
        },
        {
          path: '/Setting/MailTemplate',
          name: 'MailTemplate',
          component: () => import('./views/settings/mailTemplate/MailTemplate.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'MailTemplate', active: true },
            ],
            pageTitle: "MailTemplate"
          }
        },
        {
          path: '/Setting/SystemMailTemplate',
          name: 'SystemMailTemplate',
          component: () => import('./views/settings/systemMailTemplate/MailTemplate.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'SystemMailTemplate', active: true },
            ],
            pageTitle: "SystemMailTemplate"
          }
        },
        {
          path: '/Setting/Facility',
          name: 'Facility',
          component: () => import('./views/settings/facility/Facility.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Facility', active: true },
            ],
            pageTitle: "Facility"
          }
        },
        {
          path: '/Setting/Category',
          name: 'Category',
          component: () => import('./views/settings/category/Category.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'ExamQuestionCategory', active: true },
            ],
            pageTitle: "ExamQuestionCategory"
          }
        },
        {
          path: '/Setting/Room',
          name: 'Room',
          component: () => import('./views/settings/room/Room.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Room', active: true },
            ],
            pageTitle: "Room"
          }
        },
        {
          path: '/Setting/Room-Edit/:ID?',
          name: 'Room-add/Edit',
          component: () => import('./views/settings/room/Room-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Room', url: '/Setting/Room' },
              { title: 'RoomAddEdit', active: true },
            ],
            pageTitle: "RoomAddEdit"
          }
        },
        {
          path: '/Setting/RoomFacility',
          name: 'RoomFacility',
          component: () => import('./views/settings/roomFacility/RoomFacility.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'RoomFacility', active: true },
            ],
            pageTitle: "RoomFacility"
          }
        },
        {
          path: '/RoomPrice',
          name: 'RoomPrice',
          component: () => import('./views/roomPrice/RoomPrice.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'RoomPrice', active: true },
            ],
            pageTitle: "RoomPrice"
          }
        },
        {
          path: '/Setting/RoomType',
          name: 'RoomFacility',
          component: () => import('./views/settings/roomType/RoomType.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'RoomType', active: true },
            ],
            pageTitle: "RoomType"
          }
        },
        {
          path: '/Setting/AdditionalFacility',
          name: 'AdditionalFacility',
          component: () => import('./views/settings/additionalFacility/AdditionalFacility.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'AdditionalServices', active: true },
            ],
            pageTitle: "AdditionalServices"
          }
        },
        {
          path: '/Setting/QuestionType',
          name: 'Question Type',
          component: () => import('./views/settings/questionType/QuestionType.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'QuestionType', active: true },
            ],
            rule: 'editor',

            pageTitle: "QuestionType"
          }
        },
        {
          path: '/Setting/QuestionLevel',
          name: 'Question Level',
          component: () => import('./views/settings/questionLevel/QuestionLevel.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'QuestionLevel', active: true },
            ],
            rule: 'editor',

            pageTitle: "QuestionLevel"
          }
        },
        {
          path: '/Setting/UserTitle',
          name: 'UserTitle',
          component: () => import('./views/settings/userTitle/UserTitle.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'UserTitle', active: true },
            ],
            rule: 'editor',

            pageTitle: "UserTitle"
          }
        },
        {
          path: '/Setting/GeneralSetting',
          name: 'GeneralSetting',
          component: () => import('./views/settings/generalSetting/GeneralSetting.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'GeneralSetting', active: true },
            ],
            rule: 'editor',

            pageTitle: "GeneralSetting"
          }
        },
        {
          path: '/Question/QuestionBank/ListOfCourses',
          name: 'QuestionBank/ListOfCourses',
          component: () => import('./views/question/questionBank/ListOfCourses.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Question', url: '/Question/QuestionBank/ListOfCourses' },
              { title: 'ListOfCourses', active: true },
            ],
            rule: 'admintrainingcoordinator',
            pageTitle: "QuestionBank"
          }
        },
        {
          path: '/Question/QuestionBank/ListOfModules/:ID?',
          name: 'QuestionBank/ListOfModules',
          component: () => import('./views/question/questionBank/ListOfModules.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Question', url: '/Question/QuestionBank/ListOfModules' },
              { title: 'ListOfModule', active: true },
            ],
            rule: 'editor',
            pageTitle: "QuestionBank"
          }
        },
        {
          path: '/Question/QuestionsBank/:CourseID?/:ModuleID?',
          name: 'QuestionBank',
          component: () => import('./views/question/questionBank/QuestionBank.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Question', url: '/Question/QuestionBank' },
              { title: 'QuestionBank', active: true },
            ],
            rule: 'editor',

            pageTitle: "QuestionBank"
          }
        },
        {
          path: '/Question/QuestionBank-edit/:ID?',
          name: 'QuestionBank-add/Edit',
          component: () => import('./views/question/questionBank/QuestionBank-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Question', url: '/Question/QuestionBank' },
              { title: 'QuestionBankAddEdit', active: true },
            ],
            pageTitle: "QuestionBankAddEdit"
          }
        },
        {
          path: '/Question/AssessmentCourseQuestion',
          name: 'AssessmentCourseQuestion',
          component: () => import('./views/question/assessmentCourseQuestion/AssessmentCourseQuestion.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseFeedbackQuestion ', active: true },
            ],
            rule: 'editor',

            pageTitle: "CourseFeedbackQuestion "
          }
        },
        {
          path: '/Question/AssessmentCourseQuestion/ListOfCategoryAssessment',
          name: 'Question Bank',
          component: () => import('./views/question/assessmentCourseQuestion/ListOfCategoryAssessment.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ListOfCategory', active: true },
            ],
            rule: 'admintrainingcoordinator',

            pageTitle: "CourseFeedbackQuestion "
          }
        },
        {
          path: '/Question/AssessmentCourseQuestion-edit',
          name: 'AssessmentCourseQuestion-add/Edit',
          component: () => import('./views/question/assessmentCourseQuestion/AssessmentCourseQuestion-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'QuestionFeedback', url: '/Question/AssessmentCourseQuestion' },
              { title: 'CourseFeedbackQuestionAddEdit', active: true },
            ],
            pageTitle: "CourseFeedbackQuestionAddEdit"
          }
        },
        {
          path: '/Question/AssessmentInstructorQuestion',
          name: 'Question Bank',
          component: () => import('./views/question/assessmentInstructorQuestion/AssessmentInstructorQuestion.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AssessmentQuestion ', active: true },
            ],
            rule: 'editor',

            pageTitle: "AssessmentQuestion "
          }
        },
        {
          path: '/Question/AssessmentInstructorQuestion-edit',
          name: 'AssessmentInstructorQuestion-add/Edit',
          component: () => import('./views/question/assessmentInstructorQuestion/AssessmentInstructorQuestion-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AssessmentQuestion', url: '/Question/AssessmentInstructorQuestion' },
              { title: 'AssessmentQuestionAddEdit', active: true },
            ],
            pageTitle: "AssessmentQuestionAddEdit"
          }
        },
        {
          path: '/PracticalExamination/GeneralPracticalQuestion',
          name: 'GeneralPracticalQuestion',
          component: () => import('./views/practicalExamination/generalPracticalQuestion/GeneralPracticalQuestion.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'PracticalEvaluationQuestion', active: true },
            ],
            rule: 'admintrainingcoordinator',
            pageTitle: "PracticalEvaluationQuestion "
          }
        },
        {
          path: '/PracticalExamination/GeneralPracticalQuestion-edit',
          name: 'GeneralPracticalQuestion-add/Edit',
          component: () => import('./views/practicalExamination/generalPracticalQuestion/GeneralPracticalQuestion-edit.vue'),
          meta: {
            rule: 'admintrainingcoordinator',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'PracticalEvaluationQuestion', url: '/PracticalExamination/GeneralPracticalQuestion' },
              { title: 'PracticalEvaluationQuestionAddEdit', active: true },
            ],
            pageTitle: "PracticalEvaluationQuestionAddEdit"
          }
        },
        {
          path: '/PracticalExamination/CoursePracticalQuestion',
          name: 'CoursePracticalQuestion',
          component: () => import('./views/practicalExamination/coursePracticalQuestion/CoursePracticalQuestion.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CoursePracticalQuestion', active: true },
            ],
            rule: 'admintrainingcoordinator',

            pageTitle: "CoursePracticalQuestion"
          }
        },
        {
          path: '/PracticalExamination/CoursePracticalQuestion-edit',
          name: 'CoursePracticalQuestion-add/Edit',
          component: () => import('./views/practicalExamination/coursePracticalQuestion/CoursePracticalQuestion-edit.vue'),
          meta: {
            rule: 'admintrainingcoordinator',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CoursePracticalQuestion', url: '/PracticalExamination/CoursePracticalQuestion' },
              { title: 'CoursePracticalQuestionAddEdit', active: true },
            ],
            pageTitle: "CoursePracticalQuestionAddEdit"
          }
        },
        {
          path: '/PracticalExamination/PracticalProcess',
          name: 'PracticalProcess',
          component: () => import('./views/practicalExamination/PracticalProcess.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'PracticalProcess', active: true },
            ],
            rule: 'admintrainingcoordinator',
            pageTitle: "PracticalProcess "
          }
        },
        {
          path: '/Setting/ExamType',
          name: 'Exam Type',
          component: () => import('./views/settings/examType/ExamType.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'ExamType', active: true },
            ],
            rule: 'editor',

            pageTitle: "ExamType"
          }
        },

        {
          path: '/Setting/ClassRoom',
          name: 'ClassRoom',
          component: () => import('./views/settings/classRoom/ClassRoom.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'ClassRoom', active: true },
            ],
            pageTitle: "ClassRoom"
          }
        },

        {
          path: '/Setting/ClassRoom-Edit/:ID?',
          name: 'ClassRoom-add/Edit',
          component: () => import('./views/settings/classRoom/ClassRoom-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'ClassRoom', url: '/Setting/ClassRoom' },
              { title: 'ClassRoomAddEdit', active: true },
            ],
            pageTitle: "ClassRoomAddEdit"
          }
        },
        {
          path: '/Setting/CourseType',
          name: 'Course Type',
          component: () => import('./views/settings/courseType/CourseType.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'CourseType', active: true },
            ],
            rule: 'editor',

            pageTitle: "CourseType"
          }
        },
        {
          path: '/Setting/CourseLevel',
          name: 'Course Level',
          component: () => import('./views/settings/courseLevel/CourseLevel.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'CourseLevel', active: true },
            ],
            rule: 'editor',

            pageTitle: "CourseLevel"
          }
        },
        {
          path: '/Setting/MaterialType',
          name: 'Material Type',
          component: () => import('./views/settings/materialType/MaterialType.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'MaterialType', active: true },
            ],
            rule: 'editor',

            pageTitle: "MaterialType"
          }
        },
        {
          path: '/Setting/PopulationList',
          name: 'Population List',
          component: () => import('./views/settings/populationList/PopulationList.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'PopulationList', active: true },
            ],
            pageTitle: "PopulationList"
          }
        },
        {
          path: '/Setting/provider',
          name: 'Provider',
          component: () => import('./views/settings/provider/Provider.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Provider', active: true },
            ],
            pageTitle: "Provider"
          }
        },
        {
          path: '/Setting/IndustrySector',
          name: 'Industry Sector',
          component: () => import('./views/settings/industrySector/IndustrySector.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'IndustrySector', active: true },
            ],
            pageTitle: "IndustrySector"
          }
        },
        {
          path: '/Setting/CourseAreaOfStudy',
          name: 'Area Of Study',
          component: () => import('./views/settings/courseAreaOfStudy/CourseAreaOfStudy.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'AreaOfStudy', active: true },
            ],
            pageTitle: "AreaOfStudy"
          }
        },
        {
          path: '/Setting/CourseCategory',
          name: 'Course Category',
          component: () => import('./views/settings/courseCategory/CourseCategory.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'CourseCategory', active: true },
            ],
            pageTitle: "CourseCategory"
          }
        },
        {
          path: '/Setting/Nationality',
          name: 'Nationality',
          component: () => import('./views/settings/nationality/Nationality.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Nationality', active: true },
            ],
            pageTitle: "Nationality"
          }
        },
        {
          path: '/Setting/MaritalStatus',
          name: 'MaritalStatus',
          component: () => import('./views/settings/maritalStatus/MaritalStatus.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'MaritalStatus', active: true },
            ],
            rule: 'editor',
            pageTitle: "MaritalStatus",
          }
        },
        {
          path: '/Setting/ContactType',
          name: 'ContactType',
          component: () => import('./views/settings/contactType/ContactType.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'ContactType', active: true },
            ],
            rule: 'editor',
            pageTitle: "ContactType",
          }
        },
        {
          path: '/Setting/InstructorStatus',
          name: 'InstructorStatus',
          component: () => import('./views/settings/instructorStatus/InstructorStatus.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'InstructorStatus', active: true },
            ],
            rule: 'editor',
            pageTitle: "InstructorStatus",
          }
        },
        {
          path: '/Setting/EducationDegree',
          name: 'EducationDegree',
          component: () => import('./views/settings/educationDegree/EducationDegree.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'EducationDegree', active: true },
            ],
            rule: 'editor',
            pageTitle: "EducationDegree",
          }
        },
        {
          path: '/Setting/GenerateCode',
          name: 'Generate Code',
          component: () => import('./views/settings/generateCode/GenerateCode.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'GenerateCode', active: true },
            ],
            rule: 'editor',

            pageTitle: "GenerateCode"
          }
        },
        {
          path: '/Setting/CategoryAssessment',
          name: 'CategoryAssessment',
          component: () => import('./views/settings/categoryAssessment/CategoryAssessment.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'CustomerFeedbackCategory', active: true },
            ],
            rule: 'editor',

            pageTitle: "CustomerFeedbackCategory"
          }
        },
        {
          path: '/Setting/AssessmentType',
          name: 'Assessment Type',
          component: () => import('./views/settings/assessmentType/AssessmentType.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'AssessmentType', active: true },
            ],
            rule: 'editor',

            pageTitle: "AssessmentType"
          }
        },
        {
          path: '/Setting/Documentation',
          name: 'Documentation',
          component: () => import('./views/settings/documentation/Documentation.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Documentation', active: true },
            ],
            rule: 'editor',

            pageTitle: "Documentation"
          }
        },
        {
          path: '/Statistics/Assessment',
          name: 'Assessment ',
          component: () => import('./views/statistics/assessment/Assessment.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard' },
              { title: 'Feedback', active: true },
            ],
            rule: 'editor',

            pageTitle: "Feedback"
          }
        },
        {
          path: '/CustomerReview/CourseReview',
          name: 'CourseReview ',
          component: () => import('./views/customerReview/courseReview/CourseReview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseFeedback', active: true },
            ],
            rule: 'admintrainingcoordinator',

            pageTitle: "CourseFeedback"
          }
        },
        {
          path: '/CustomerReview/CourseReview-edit',
          name: 'CourseReview-add/Edit',
          component: () => import('./views/customerReview/courseReview/CourseReview-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseFeedback', url: '/CustomerReview/CourseReview' },
              { title: 'CourseFeedbackAddEdit', active: true },
            ],
            pageTitle: "CourseFeedbackAddEdit"
          }
        },
        {
          path: '/CustomerReview/InstructorAssessment',
          name: 'InstructorReview ',
          component: () => import('./views/customerReview/instructorReview/InstructorReview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'InstructorAssessment', active: true },
            ],
            rule: 'editor',

            pageTitle: "InstructorAssessment"
          }
        },
        {
          path: '/CustomerReview/InstructorAssessment-edit',
          name: 'InstructorReview-add/Edit',
          component: () => import('./views/customerReview/instructorReview/InstructorReview-edit.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'InstructorAssessment', url: '/CustomerReview/InstructorReview' },
              { title: 'InstructorAssessmentAddEdit', active: true },
            ],
            pageTitle: "InstructorAssessmentAddEdit"
          }
        },
        // {
        //     path: '/foodtype',
        //     name: 'FoodTypeList',
        //     component: () => import('@/views/foodtype/FoodType.vue'),
        //     meta: {
        //         breadcrumb: [
        //             { title: 'Home', url: '/' },
        //             { title: 'Setting' },
        //             { title: 'Food Type', active: true },
        //         ],
        //         pageTitle: 'Food Type',
        //         rule: 'editor'
        //     },
        // },

        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: '/Diplomas',
          name: 'Diplomas',
          component: () => import('@/views/track/ViewTrack.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Diplomas', active: true },
            ],
            pageTitle: 'Diplomas',
            rule: 'customertrainee'
          },
        },
        {
          path: '/diploma_programs/:ID?',
          name: 'diploma_programs',
          component: () => import('@/views/track/TrackDetail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ProgramDetail', active: true },
            ],
            pageTitle: 'ProgramDetail',
            rule: 'customertrainee'
          },
        },
        {
          path: '/Schedule',
          name: 'TraineeSchedule',
          component: () => import('@/views/trainee/CourseClassSchedule.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Schedule', active: true },
            ],
            pageTitle: 'Schedule',
            rule: 'trainee'
          },
        },
        {
          path: '/AvailableExam',
          name: 'AvailableExam',
          component: () => import('@/views/trainee/availableExam/availableExam.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AvailableExam', active: true },
            ],
            pageTitle: 'AvailableExam',
            rule: 'trainee'
          },
        },
        {
          path: '/ExamAnswer/:Code?',
          name: 'ExamAnswer',
          component: () => import('@/views/trainee/availableExam/ExamAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ExamAnswer', active: true },
            ],
            pageTitle: 'ExamAnswer',
            rule: 'trainee'
          },
        },
        {
          path: '/pages/profile',
          name: 'page-profile',
          component: () => import('@/views/pages/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Profile', active: true },
            ],
            pageTitle: 'Profile',
            rule: 'editor'
          },
        },
        {
          path: '/profile',
          name: 'Traineeprofile',
          component: () => import('@/views/trainee/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },

              { title: 'Profile', active: true },
            ],
            pageTitle: 'Profile',
            rule: 'trainee'
          },
        },
        {
          path: '/CustomerProfile',
          name: 'CustomerProfile',
          component: () => import('@/views/customer/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Profile', active: true },
            ],
            pageTitle: 'Profile',
            rule: 'customer'
          },
        },
        {
          path: '/InstructorProfile',
          name: 'InstructorProfile',
          component: () => import('@/views/instructor/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Profile', active: true },
            ],
            pageTitle: 'Profile',
            rule: 'instructor'
          },
        },
        {
          path: '/ChangePassword',
          name: 'ChangePassword',
          component: () => import('@/views/changePassword.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },

              { title: 'ChangePassword', active: true },
            ],
            pageTitle: 'Change Password',
            rule: 'all'
          },
        },
        {
          path: '/planning',
          name: 'planning',
          component: () => import('@/views/planning/AnnualPlan.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Planning' },

            ],
            pageTitle: 'Planning',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/planning/AnnualPlan',
          name: 'annual-plan',
          component: () => import('@/views/planning/AnnualPlan.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Planning' },
              { title: 'AnnualPlan', active: true },
            ],
            pageTitle: 'AnnualPlan',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/planning/RoomPlan',
          name: 'RoomPlan',
          component: () => import('@/views/planning/RoomPlan.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Planning' },
              { title: 'RoomPlan', active: true },
            ],
            pageTitle: 'RoomPlan',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/planning/AnnualPlanCosting',
          name: 'AnnualPlanCosting',
          component: () => import('@/views/planning/AnnualPlanCosting.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Planning' },
              { title: 'AnnualPlanCosting', active: true },
            ],
            pageTitle: 'AnnualPlanCosting',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/CourseClass',
          name: 'CourseClass',
          component: () => import('@/views/courseClass/CourseClass.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseClass', active: true },
            ],
            pageTitle: 'CourseClass',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/Setting/CourseClass-Edit/:ID?',
          name: 'Course Class-add/Edit',
          component: () => import('@/views/courseClass/CourseClass-Edit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CourseClassAddEdit', active: true },
            ],
            pageTitle: 'CourseClassAddEdit',
            rule: 'admintrainingcoordinator'
          },
        },

        {
          path: '/planning/YearSummary',
          name: 'Year-Summary',
          component: () => import('@/views/planning/YearSummary.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Planning' },
              { title: 'YearSummary', active: true },
            ],
            pageTitle: 'YearSummary',
            rule: 'admintrainingcoordinator'
          },
        },

        {
          path: '/ExamGeneration',
          name: 'ExamGeneration',
          component: () => import('@/views/courseClassExam/CourseClassExam.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ExamGeneration', active: true },
            ],
            pageTitle: 'ExamGeneration',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/Exam-add/Edit',
          name: 'Exam-add/Edit',
          component: () => import('@/views/courseClassExam/CourseClassExam-edit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ExamAddEdit', active: true },
            ],
            pageTitle: 'ExamAddEdit',
            rule: 'editor'
          },
        },
        {
          path: '/TraineeAttendance',
          name: 'TraineeAttendance',
          component: () => import('@/views/traineeAttendance/TraineeAttendance.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeAttendance', active: true },
            ],
            pageTitle: 'TraineeAttendance',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/TraineeParticipation',
          name: 'TraineeParticipation',
          component: () => import('@/views/traineeParticipation/TraineeParticipation.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeParticipation', active: true },
            ],
            pageTitle: 'TraineeParticipation',
            rule: 'adminevaluatorinstructorCoordinator'
          },
        },
        {
          path: '/Planning/Holiday',
          name: 'Holiday',
          component: () => import('@/views/holiday/Holiday.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Holiday', active: true },
            ],
            pageTitle: 'Holiday',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/Setting/Country',
          name: 'Country',
          component: () => import('@/views/settings/country/Country.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'Country', active: true },
            ],
            pageTitle: 'Country',
            rule: 'editor'
          },
        },
        {
          path: '/Setting/ProposalTemplate',
          name: 'ProposalTemplate',
          component: () => import('@/views/settings/proposalTemplate/ProposalTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'CustomizedProposal', active: true },
            ],
            pageTitle: 'CustomizedProposal',
            rule: 'editor'
          },
        },
        {
          path: '/Setting/ProposalStatus',
          name: 'ProposalStatus',
          component: () => import('@/views/settings/proposalStatus/ProposalStatus.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'ProposalStatus', active: true },
            ],
            pageTitle: 'ProposalStatus',
            rule: 'editor'
          },
        },
        {
          path: '/Setting/TrainingStrategy',
          name: 'TrainingStrategy',
          component: () => import('@/views/settings/trainingStrategy/TrainingStrategy.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'TrainingStrategy', active: true },
            ],
            pageTitle: 'TrainingStrategy',
            rule: 'editor'
          },
        },
        {
          path: '/Setting/AdvertisementEmail',
          name: 'AdvertisementEmail',
          component: () => import('@/views/settings/advertisementEmail/AdvertisementEmail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'AdvertisementEmail', active: true },
            ],
            pageTitle: 'AdvertisementEmail',
            rule: 'editor'
          },
        },
        {
          path: '/Setting/GeneralImage',
          name: 'GeneralImage',
          component: () => import('@/views/settings/generalImage/GeneralImage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Setting' },
              { title: 'GeneralImageForMail', active: true },
            ],
            pageTitle: 'GeneralImageForMail',
            rule: 'editor'
          },
        },
        {
          path: '/TraineeExamsAnswers',
          name: 'TraineeExamsAnswers',
          component: () => import('@/views/traineeExamsAnswers/ListOfTrainee.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeExamsAnswers', active: true },
            ],
            pageTitle: 'TraineeExamsAnswers',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/TraineeExam/:CourseClassID?/:ID?',
          name: 'TraineeExam',
          component: () => import('@/views/traineeExamsAnswers/TraineeExam.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeExam', active: true },
            ],
            pageTitle: 'TraineeExam',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/TraineeExamWithAnswer/:CourseClassID?/:TraineeID?/:ExamID?',
          name: 'TraineeExamWithAnswer',
          component: () => import('@/views/traineeExamsAnswers/TraineeExamWithAnswer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeExamWithAnswer', active: true },
            ],
            pageTitle: 'TraineeExamWithAnswer',
            rule: 'admintrainingcoordinator'
          },
        },
        {
          path: '/RegisterConfirmation/:Code?',
          // path: '/RegisterConfirmation',
          name: 'RegisterConfirmation',
          component: () => import('@/views/RegisterConfirmation.vue'),
          meta: {
            pageTitle: 'RegisterConfirmation',
            rule: 'customer',
            authRequired: true,
          }
        },
        {
          path: '/InstructorConfirmation/:ID?',
          // path: '/RegisterConfirmation',
          name: 'InstructorConfirmation',
          component: () => import('@/views/InstructorConfirmation.vue'),
          meta: {
            pageTitle: 'InstructorConfirmation',
            rule: 'instructor',
            authRequired: true
          }
        },
        {
          path: '/InstructorClassConfirmation/:ID?',
          // path: '/RegisterConfirmation',
          name: 'InstructorClassConfirmation',
          component: () => import('@/views/InstructorClassConfirmation.vue'),
          meta: {
            pageTitle: 'InstructorConfirmation',
            rule: 'instructor',
          }
        },
        // {
        //     path: '/TraineeCoursesInstructor',
        //     name: 'TraineeCoursesInstructor',
        //     component: () => import('@/views/traineeCoursesInstructor/TraineeCoursesInstructor.vue'),
        //     meta: {
        //         breadcrumb: [
        //             { title: 'Home', url: '/' },
        //             { title: 'TraineeCoursesInstructor' },
        //             // { title: 'Trainee Courses Instructor', active: true },
        //         ],
        //         pageTitle: 'Trainee Courses Instructor',
        //         rule: 'editor'
        //     },
        // }
        {
          path: '/InstructorCourseEvaluation',
          name: 'InstructorCourseEvaluation',
          component: () => import('@/views/instructor/InstructorCourseEvaluation.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Feedback', active: true },
            ],
            pageTitle: 'Feedback',
            rule: 'instructor'
          },
        },

        {
          path: '/TraineeCoursesInstructor',
          name: 'TraineeCoursesInstructor',
          component: () => import('@/views/traineeCoursesInstructor/TraineeCoursesInstructor.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'PracticalDegree', active: true },
            ],
            pageTitle: 'PracticalDegree',
            rule: 'instructor'
          },
        },


        {
          path: '/TraineeCourses',
          name: 'CoursesInstructorTrainee',
          component: () => import('@/views/traineeCoursesInstructor/TraineeCourses.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeCoursesInstructor' },
              { title: 'TraineeCourses', active: true },
            ],
            pageTitle: 'TraineeCourses',
            rule: 'instructor'
          },
        },
        {
          path: '/TraineePass',
          name: 'TraineePasscaseInstructor',
          component: () => import('@/views/traineeCoursesInstructor/TraineePass.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeCoursesInstructor' },
              { title: 'TraineePass', active: true },
            ],
            pageTitle: 'TraineePass',
            rule: 'instructor'
          },
        },
        {
          path: '/TraineePractical',
          name: 'TraineePractical',
          component: () => import('@/views/traineeCoursesInstructor/TraineePractical.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeCoursesInstructor' },
              { title: 'TraineePractical', active: true },
            ],
            pageTitle: 'TraineePractical',
            rule: 'instructor'
          },
        },
        {
          path: '/TraineeCoursesPass',
          name: 'TraineeCoursesPass',
          component: () => import('@/views/traineeCoursesPass/TraineeCourses.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'TraineeCourses', active: true },
            ],
            pageTitle: 'TraineeCourses',
            rule: 'trainee'
          },
        },
        {
          path: '/TraineeCoursePass/:CourseClassID?/:TraineeID?',
          name: 'TraineePasscaseTrainee',
          component: () => import('@/views/traineeCoursesPass/TraineePagePass.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'trainee Courses Instructor' },
              { title: 'TraineePass', active: true },
            ],
            pageTitle: 'TraineePass',
            rule: 'trainee'
          },
        },
        {
          path: '/Reports',
          name: 'Reports',
          component: () => import('@/views/report/Reports.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },

              { title: 'RecordsReports', active: true },
            ],
            rule: 'editor',
            pageTitle: "RecordsReports",
          }
        },
        {
          path: '/Setting/ReportManagement',
          name: 'ReportManagement',
          component: () => import('@/views/settings/report/Report.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports', active: true },
            ],
            rule: 'editor',
            pageTitle: "Reports",
          }
        },
        {
          path: '/DubaiEvent',
          name: 'DubaiEvent',
          component: () => import('./views/dubaiEvent/DubaiEvent.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dubai Event', url: '/DubaiEvent/', active: true },
            ],
            rule: 'editor',
            pageTitle: "Dubai Event"
          },

        },

      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        // {
        //     path: '/callback',
        //     name: 'auth-callback',
        //     component: () => import('@/views/Callback.vue'),
        //     meta: {
        //         rule: 'editor'
        //     }
        // },
        {
          path: '/pages/login/:IncomeCode?',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "Login",
          }
        },

        {
          path: '/report/CourseDetail/:ID?',
          name: 'CourseDetail',
          component: () => import('@/views/report/CourseDetail.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseDetailReport",
          }
        },
        {
          path: '/report/UpcomingCourseDetail/:ID?',
          name: 'UpcomingCourseDetail',
          component: () => import('@/views/report/UpcomingCourseDetail.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "UpcomingCourseDetailReport",
          }
        },
        {
          path: '/report/CourseRegistrationInvoice/:ID?/:AnnualPlanID?',
          name: 'CourseRegistrationInvoiceReport',
          component: () => import('@/views/report/CourseRegistrationInvoice.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseRegistrationInvoiceReport",
          }
        },
        {
          path: '/report/CourseRequestInvoice/:ID?',
          name: 'CourseRequestInvoiceReport',
          component: () => import('@/views/report/CourseRequestInvoice.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseRequestInvoiceReport",
          }
        },
        {
          path: '/report/DiplomaDetail/:ID?',
          name: 'DiplomaDetail',
          component: () => import('@/views/report/DiplomaDetail.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "DiplomaDetailReport",
          }
        },
        {
          path: '/report/Certificate/:CourseClassID?/:TraineeID?',
          name: 'CertificateReport',
          component: () => import('@/views/report/Certificate.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CertificateReport",
          }
        },
        {
          path: '/report/AttendeCertificate/:CourseClassID?/:TraineeID?',
          name: 'AttendeCertificate',
          component: () => import('@/views/report/AttendeCertificate.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CertificateReport",
          }
        },
        {
          path: '/report/InstructorAssessment/:ID?',
          name: 'InstructorAssessmentReport',
          component: () => import('@/views/report/InstructorAssessment.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "InstructorAssessmentReport",
          }
        },
        {
          path: '/report/InstructorAssessmentAnswer/:ID?',
          name: 'InstructorAssessmentAnswerReport',
          component: () => import('@/views/report/InstructorAssessmentAnswer.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "InstructorAssessmentAnswerReport",
          }
        },
        {
          path: '/report/CourseFeedBack/:CourseID?/:CourseTypeID?',
          name: 'CourseFeedBackReport',
          component: () => import('@/views/report/CourseFeedBack.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseFeedbackReport",
          }
        },
        {
          path: '/report/CourseFeedBackAnswer/:CourseClassID?/:TraineeID?',
          name: 'CourseFeedBackAnswerReport',
          component: () => import('@/views/report/CourseFeedBackAnswer.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseFeedbackReport",
          }
        },
        {
          path: '/report/TraineeAttendanceSheet/:CourseClassID?/:Day?',
          name: 'TraineeAttendanceSheetReport',
          component: () => import('@/views/report/TraineeAttendanceSheet.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "TraineeAttendanceReport",
          }
        },
        {
          path: '/report/DailyAttendanceSheet/:CourseClassID?',
          name: 'DailyAttendanceSheet',
          component: () => import('@/views/report/DailyAttendanceSheet.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "DailyAttendanceReport",
          }
        },
        {
          path: '/report/InstructorLogin/:CourseClassID?',
          name: 'InstructorLogin',
          component: () => import('@/views/report/InstructorLogin.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "InstructorLogInReport",
          }
        },
        {
          path: '/report/AuthorizationOfInstruction/:InstructorID?/:CourseClassID',
          name: 'AuthorizationOfInstruction',
          component: () => import('@/views/report/AuthorizationOfInstruction.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "AuthorizationOfInstruction",
          }
        },
        {
          path: '/report/RegistrationForm/:RegistrationID?/:TraineeID?',
          name: 'RegistrationForm',
          component: () => import('@/views/report/RegistrationForm.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "RegistrationForm",
          }
        },
        {
          path: '/report/RegistrationCheckList/:CourseName?',
          name: 'RegistrationCheckList',
          component: () => import('@/views/report/RegistrationCheckList.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CheckList",
          }
        },
        {
          path: '/report/CourseExam/:CourseClassExamsID?',
          name: 'CourseExam',
          component: () => import('@/views/report/CourseExam.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseExam",
          }
        },
        {
          path: '/report/CourseExamAnswer/:CourseClassExamsID?/:TraineeID?',
          name: 'CourseExam',
          component: () => import('@/views/report/CourseExamAnswer.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseExamAnswer",
          }
        },
        {
          path: '/report/TraininingCourseStatistic/:CourseIDs?/:dateFrom?/:dateTo?',
          name: 'TraininingCourseStatistic',
          component: () => import('@/views/report/TraininingCourseStatistic.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "TraininingCourseStatistic",
          }
        },
        {
          path: '/report/FinancialPorposal/:CourseRequestId?/:Fees?/:NoTrainee?/:CourseHours?',
          name: 'FinancialPorposal',
          component: () => import('@/views/report/FinancialPorposal.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "FinancialPorposal",
          }
        },
        {
          path: '/report/CoursePractical/:CourseClassID?/:TraineeID?',
          name: 'CoursePractical',
          component: () => import('@/views/report/CoursePractical.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CoursePractical",
          }
        },
        {
          path: '/report/GeneralPractical/:CourseClassID?/:TraineeID?',
          name: 'GeneralPractical',
          component: () => import('@/views/report/GeneralPractical.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CoursePractical",
          }
        },
        {
          path: '/report/FinalEvaluation/:CourseClassID?/:TraineeID?',
          name: 'FinalEvaluation',
          component: () => import('@/views/report/FinalEvaluation.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "FinalEvaluation",
          }
        },
        {
          path: '/report/DialyFollowUpTrainingEvaluation/:CourseClassID?/:Day?/:ModuleID?',
          name: 'DialyFollowUpTrainingEvaluation',
          component: () => import('@/views/report/DialyFollowUpTrainingEvaluation.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "DialyFollowUpTrainingEvaluation",
          }
        },

        {
          path: '/report/SingleCourseAdvertV1/:AnnualPlanID?',
          name: 'SingleCourseAdvertV1',
          component: () => import('@/views/report/SingleCourseAdvertV1.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "SingleCourseAdvertV1",
          }
        },
        {
          path: '/report/InstructorProfile/:InstructorID?',
          name: 'InstructorProfile',
          component: () => import('@/views/report/InstructorProfile.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "InstructorProfile",
          }
        },
        {
          path: '/report/TraineeProfile/:TraineeID?',
          name: 'TraineeProfile',
          component: () => import('@/views/report/TraineeProfile.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "TraineeProfile",
          }
        },
        {
          path: '/report/OrganizationProfile/:OrganizationID?',
          name: 'OrganizationProfile',
          component: () => import('@/views/report/OrganizationProfile.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "OrganizationProfile",
          }
        },
        {
          path: '/report/AnnualPlanGridView/:CourseIDs?/:DateFrom?/:DateTo?',
          name: 'AnnualPlanGridView',
          component: () => import('@/views/report/AnnualPlanGridView.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "AnnualPlanGridView",
          }
        },
        {
          path: '/report/ClassRoomSchedule/:ClassIDs?/:DateFrom?/:DateTo?',
          name: 'ClassRoomSchedule',
          component: () => import('@/views/report/ClassRoomSchedule.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "ClassRoomSchedule",
          }
        },
        {
          path: '/report/TraineeRequestForm/:RequestID?/:TraineeID?',
          name: 'TraineeRequestForm',
          component: () => import('@/views/report/TraineeRequestForm.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "TraineeRequestForm",
          }
        },
        {
          path: '/report/OrganizationRequestForm/:RequestID?',
          name: 'OrganizationRequestForm',
          component: () => import('@/views/report/OrganizationRequestForm.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "OrganizationRequestForm",
          }
        },
        {
          path: '/report/CourseClassEvaluationMeanStatistic/:CourseClassID?',
          name: 'CourseClassEvaluationMeanStatistic',
          component: () => import('@/views/report/CourseClassEvaluationMeanStatistic.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseClassEvaluationMeanStatistic",
          }
        },
        {
          path: '/report/CourseRequestInvitation/:CourseRequestID?',
          name: 'CourseRequestInvitation',
          component: () => import('@/views/report/CourseRequestInvitation.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseClassEvaluationMeanStatistic",
          }
        },
        {
          path: '/report/CourseRequestPlacement/:CourseRequestID?',
          name: 'CourseRequestPlacement',
          component: () => import('@/views/report/CourseRequestPlacement.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseClassEvaluationMeanStatistic",
          }
        },
        {
          path: '/report/RegistrationPlacementLetterReport/:CourseRegistraionID?/:AnnualPlanID?',
          name: 'RegistrationPlacementLetterReport',
          component: () => import('@/views/report/RegistrationPlacementLetterReport.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseClassEvaluationMeanStatistic",
          }
        },
        {
          path: '/report/RegistrationInvitation/:CourseRegistraionID?/:AnnualPlanID?',
          name: 'RegistrationInvitation',
          component: () => import('@/views/report/RegistrationInvitation.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CourseClassEvaluationMeanStatistic",
          }
        },
        {
          path: '/report/TrainingOrder/:CourseClassID?',
          name: 'TrainingOrder',
          component: () => import('@/views/report/TrainingOrder.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "TrainingOrder",
          }
        },
        {
          path: '/report/TraininingCourseStatisticChart/:DateForm?/:DateTo?',
          name: 'TraininingCourseStatisticChart',
          component: () => import('@/views/report/TraininingCourseStatisticChart.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "TrainingOrder",
          }
        },
        {
          path: '/report/AnnualPlan/:DateForm?/:DateTo?',
          name: 'AnnualPlan',
          component: () => import('@/views/report/AnnualPlan.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "AnnualPlan",
          }
        },
        {
          path: '/report/TraineeEmails',
          name: 'TraineeEmails',
          component: () => import('@/views/report/TraineeEmails.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "TraineeEmails",
          }
        },
        // {
        //     path: '/pages/register',
        //     name: 'page-register',
        //     component: () => import('@/views/pages/register/Register.vue'),
        //     meta: {
        //         rule: 'anonymous',
        //         pageTitle : "Register ",
        //     }
        // },
        {
          path: '/registration/registerType',
          name: 'registerType',
          component: () => import('@/views/pages/register/RegisterType.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "Register",
          }
        },
        {
          path: '/registration/TraineeRegister',
          name: 'TraineeRegister',
          component: () => import('@/views/pages/register/TraineeRegister.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "Register",
          }
        },
        {
          path: '/registration/CustomerRegister',
          name: 'CustomerRegister',
          component: () => import('@/views/pages/register/CustomerRegister.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "Register",
          }
        },

        {
          path: '/registration/InstructorRegister',
          name: 'InstructorRegister',
          component: () => import('@/views/pages/register/InstructorRegistration.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "Register",
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "ForgotPassword",
          }
        },
        {
          path: '/pages/CheckCode/:Email?',
          name: 'CheckCode',
          component: () => import('@/views/pages/CheckCode.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "CheckCode",
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "ResetPassword",
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor',
            pageTitle: "LockScreen",
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'anonymous',
            pageTitle: "ComingSoon",
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'anonymous'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'anonymous'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

router.beforeEach((to, from, next) => {
  // firebase.auth().onAuthStateChanged(() => {

  //     // get firebase current user
  //     const firebaseCurrentUser = firebase.auth().currentUser

  // if (
  //     to.path === "/pages/login" ||
  //     to.path === "/pages/forgot-password" ||
  //     to.path === "/pages/error-404" ||
  //     to.path === "/pages/error-500" ||
  //     to.path === "/pages/register" ||
  //     to.path === "/callback" ||
  //     to.path === "/pages/comingsoon" ||
  //     (auth.isAuthenticated() || firebaseCurrentUser)
  // ) {
  //     return next();
  // }

  // If auth required, check login. If login fails redirect to login page
  debugger
  if (to.meta.authRequired) {
    if (!(auth.isAuthenticated())) {
      debugger
      router.push({ path: '/pages/login/' + to.params.ID, query: { to: to.path }, params: to.params })
      // router.push({ path: '/pages/login', query: { to: to.path } })
    }
  }

  return next()
  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  // auth.login({ target: to.path });

  //});

});

export default router
